import { Component, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { CoreServicesModule } from '../../core/core.services.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { ChatRenderService } from './services/gfchat.service';
import { ChatMacroService } from './services/gfchat.macro.service';
import { LinkRendersComponent } from './link-renders/chat.link-renders.component';
import { MessageListComponent } from './message-list/chat.message-list.component';
import { GfChatComponent } from './gfChat/gfchat.component';
import { CoreWidgetsModule } from '../../widgets/core.widgets.module';

import { StandaloneChatViewComponent } from './sachat/sachat.component';
import { StandaloneChatTopComponent } from './sachat-top/sachat.top.component';
import { EmbeddedChatComponent } from './embedded/chat.embedded.component';

import { AccountWidget } from './account-widget/account-widget.component';

@Component({
    template: require('../../../error.html')
  })
export class ErrorComponent {}

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        CoreServicesModule,
        CoreFiltersModule,
        CoreWidgetsModule,
        FormsModule
    ],
    declarations: [
        LinkRendersComponent,
        MessageListComponent,
        GfChatComponent,
        StandaloneChatViewComponent,
        StandaloneChatTopComponent,
        EmbeddedChatComponent,
        ErrorComponent,
        AccountWidget
    ],
    exports: [
        LinkRendersComponent,
        MessageListComponent,
        GfChatComponent,
        EmbeddedChatComponent
    ],
    providers: [
        ChatRenderService,
        ChatMacroService
    ],
})
export class ChatModule {
    constructor() { }
}
